var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 14,
    fill: "#6B59CC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 14,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.196 28.0682C22.2964 28.9678 21.2311 29.4176 20 29.4176C18.7689 29.4176 17.7036 28.9678 16.804 28.0682C15.9044 27.1685 15.4545 26.1032 15.4545 24.8721V15.7812C15.4545 14.5502 15.9044 13.4848 16.804 12.5852C17.7036 11.6856 18.7689 11.2358 20 11.2358C21.2311 11.2358 22.2964 11.6856 23.196 12.5852C24.0956 13.4848 24.5455 14.5502 24.5455 15.7812V24.8721C24.5455 26.1032 24.0956 27.1685 23.196 28.0682ZM21.4915 35.0284V40H18.5085V35.0284C15.9991 34.6496 13.8565 33.5014 12.081 31.5838C10.3054 29.6662 9.41762 27.429 9.41762 24.8721H11.9744C11.9744 27.0975 12.7675 28.9323 14.3537 30.3764C15.9399 31.8205 17.822 32.5426 20 32.5426C22.178 32.5426 24.0601 31.8205 25.6463 30.3764C27.2325 28.9323 28.0256 27.0975 28.0256 24.8721H30.5824C30.5824 27.429 29.6946 29.6662 27.919 31.5838C26.1435 33.5014 24.001 34.6496 21.4915 35.0284Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a6f42698c426ad3b6f6bf83f94ddc1a3.svg";
export { ForwardRef as ReactComponent };